import script from "./ModalError.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalError.vue?vue&type=script&setup=true&lang=js"

import "./ModalError.vue?vue&type=style&index=0&id=317aa0b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-317aa0b3"]])

export default __exports__